import type { SVGProps } from 'react';

interface DuplicateIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function DuplicateIcon({ className, ...props }: DuplicateIconProps) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <rect
        x="4"
        y="4"
        width="8.5"
        height="8.5"
        rx="1.5"
        stroke="currentColor"
        strokeWidth="1.2"
      />
      <path
        d="M10 4V2.5C10 1.67157 9.32843 1 8.5 1H2.5C1.67157 1 1 1.67157 1 2.5V8.5C1 9.32843 1.67157 10 2.5 10H4"
        stroke="currentColor"
        strokeWidth="1.2"
      />
      <path
        d="M8.25 6.25V10.75M6 8.5H10.5"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
}
